import Seo from "@/components/Seo";
import { SITE } from "@/data/site";

const SECTIONS = [
  {
    title: "Information We Collect",
    body: "When you submit a form on this website or contact us, we collect the information you provide: your name, phone number, email address, company (if provided), travel date, destination, the service you need, and your message. We use this information solely to respond to your inquiry and provide the assistance you request.",
  },
  {
    title: "How We Use Your Information",
    body: "We use the information you provide to contact you about your inquiry, prepare for consultations, and deliver the travel document assistance services you request. We do not sell, rent, or share your personal information with third parties for their marketing purposes.",
  },
  {
    title: "Service Providers",
    body: "We use limited third-party service providers (such as email delivery services) to operate this website and communicate with you. These providers process information only as needed to perform their function.",
  },
  {
    title: "Data Security",
    body: "We take reasonable measures to protect the information submitted through this website. However, no method of transmission over the internet is completely secure, and we encourage you not to submit sensitive identity documents through the website form.",
  },
  {
    title: "Your Choices",
    body: "You may contact us at any time to ask what information we hold about you or to request that we delete your inquiry information. Call us at 866-334-8472.",
  },
  {
    title: "Changes to This Policy",
    body: "We may update this Privacy Policy from time to time. The current version will always be posted on this page.",
  },
];

export default function PrivacyPage() {
  return (
    <>
      <Seo
        title="Privacy Policy | Travel Passport and Visa LLC"
        siteName={SITE.siteName}
        description="Privacy Policy for Travel Passport and Visa LLC — how we collect, use, and protect the information you submit through this website."
      />
      <section className="grain bg-navy py-16" data-testid="privacy-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h1 className="font-display text-4xl font-bold tracking-tight text-white sm:text-5xl" data-testid="privacy-h1">
            Privacy Policy
          </h1>
          <p className="mt-4 text-sm text-slate-400">{SITE.name} — Washington, DC</p>
        </div>
      </section>
      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl space-y-10 px-4 sm:px-6" data-testid="privacy-content">
          {SECTIONS.map((s) => (
            <div key={s.title}>
              <h2 className="font-display text-xl font-bold text-navy">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </div>
          ))}
          <div className="rounded-xl border-l-4 border-gold bg-slate-50 p-6">
            <p className="text-sm leading-relaxed text-slate-600">{SITE.disclosure}</p>
          </div>
        </div>
      </section>
    </>
  );
}
